const toggleButtons = document.querySelectorAll('.toggle-search');
for (const button of toggleButtons) {
    button.addEventListener('click', toggleSearch);
}
function toggleSearch() {
    var _a;
    const newState = document.body.dataset.navUi === 'search' ? 'initial' : 'search';
    document.body.dataset.navUi = newState;
    for (const button of toggleButtons) {
        button.ariaExpanded = newState === 'search' ? 'true' : 'false';
    }
    if (newState === 'search') {
        (_a = document
            .querySelector('.site-search [type="search"]')) === null || _a === void 0 ? void 0 : _a.focus();
        const menuButton = document.querySelector('.menu-toggle');
        menuButton === null || menuButton === void 0 ? void 0 : menuButton.classList.remove('is-active');
        menuButton === null || menuButton === void 0 ? void 0 : menuButton.setAttribute('aria-expanded', 'false');
    }
}
export {};
